import AwesomeSlider from 'react-awesome-slider';
import WithAutoplay from 'react-awesome-slider/dist/autoplay';
import 'react-awesome-slider/src/styles';
import './slider.scss';

import { baseURL } from '../../../api';


const AutoplaySlider = WithAutoplay(AwesomeSlider);

const Slider = ({bannerData}) => {
    const validBanners = bannerData ? bannerData.filter(v => v && v.url) : [];
    if (validBanners.length === 0) return null;

    return (
        <div className="default-slider">
            <AutoplaySlider
                bullets={true}
                play={true}
                organicArrows={false}
                cancelOnInteraction={false} // should stop playing on user interaction
                interval={3000}
                showTimer={true}
            >
                {validBanners.map((value)=>{
                    return (
                        <div key={value._id || value.id || value.url} data-src={`${baseURL}${value.url}`} />
                    )
                })}
            </AutoplaySlider>
        </div>
    )
}

export default Slider;
